import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IBeneficiariesState } from './beneficiaries.state';

export class BeneficiariesSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly beneficiariesState = (state: IRootState): IBeneficiariesState => {
    return state.beneficiaries as IBeneficiariesState;
  };

  static readonly model = createSelector(
    BeneficiariesSelectors.beneficiariesState,
    (beneficiaries: IBeneficiariesState) => {
      return beneficiaries.model;
    }
  );

  static readonly data = createSelector(
    BeneficiariesSelectors.beneficiariesState,
    (beneficiaries: IBeneficiariesState) => {
      return beneficiaries.data;
    }
  );

  static readonly addedBeneficiaries = createSelector(
    BeneficiariesSelectors.beneficiariesState,
    (beneficiaries: IBeneficiariesState) => {
      return beneficiaries.addedBeneficiaries;
    }
  );

  static readonly selectedBeneficiary = createSelector(
    BeneficiariesSelectors.beneficiariesState,
    (beneficiaries: IBeneficiariesState) => {
      return beneficiaries.selectedBeneficiary;
    }
  );

  static readonly beneficiaryFormMode = createSelector(
    BeneficiariesSelectors.beneficiariesState,
    (beneficiaries: IBeneficiariesState) => {
      return beneficiaries.beneficiaryFormMode;
    }
  );
}
